import { Component } from '@angular/core';
import { OngletlayoutComponent } from "../../../../components/layouts/ongletlayout/ongletlayout.component";
import { routeAlias } from '../../../../../routesalias';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-comptabilite',
  imports: [OngletlayoutComponent, RouterOutlet],
  templateUrl: './comptabilite.component.html',
  styleUrl: './comptabilite.component.css'
})
export class ComptabiliteLayout {
  tableLinkForComptabilite = [
    {
      text: "Type Compte",
      link: routeAlias.parameters.comptabilites.typecompte.home,
    },
    {
      text: "Compte",
      link: routeAlias.parameters.comptabilites.compte.home,
    },
  ]
}
